export default __webpack_public_path__ + "48777b76b1b77353b9d50d94f583f762.webp";